export const AMERICAN_SLASH_DATE_FORMAT = 'MM/dd/yy';
export const AMERICAN_LONG_FULL_DATE_FORMAT = 'PPp';
